export default __webpack_public_path__ + "static/McDonalds-62b384ab95fdf5faec9e38ec55eb6611.png";